import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import { useMutation, useQuery } from '@tanstack/react-query'
import type { ComplaintForm } from './types'

export const COMPLAINT_KEYS = {
    FETCH: 'COMPLAINT',
    POST_COMPLAINT: 'POST_COMPLAINT'
}

const isClientError = code => code.toString().startsWith('4')

export const useComplaint = (token: string, options?: any) => {
    return useQuery({
        queryKey: [COMPLAINT_KEYS.FETCH],
        queryFn: async () => {
            const result = await ws.get(endpoints.complaint.get(token))
            return result.data
        },
        retry: (failureCount, error) => {
            const code = error.response.status
            if (failureCount > 3) {
                return false
            }

            if (isClientError(code)) {
                return false
            }

            return false
        },
        ...options
    })
}

const postComplaintMessage = async (form: ComplaintForm) => {
    const response = await ws.post(endpoints.complaint.postMessage, form)
    return response.data
}

export const usePostComplaint = (options?: any) => {
    return useMutation({
        mutationKey: [COMPLAINT_KEYS.POST_COMPLAINT],
        mutationFn: postComplaintMessage,
        ...options
    })
}
